import React, { useState } from 'react';
import { FaPlus, FaTrash } from 'react-icons/fa';

const ComparisonForm = ({ onSubmit }) => {
  const [products, setProducts] = useState(['', '']);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleProductChange = (index, value) => {
    const updatedProducts = [...products];
    updatedProducts[index] = value;
    setProducts(updatedProducts);
  };

  const addProductInput = () => {
    if (products.length < 4) {
      setProducts([...products, '']);
    }
  };

  const removeProductInput = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts.length ? updatedProducts : ['', '']);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Filter out empty products
    const validProducts = products.filter(product => product.trim());
    
    await onSubmit(validProducts);
    setIsSubmitting(false);
  };

  return (
    <div className="comparison-form">
      <h2 className="form-title">What would you like to compare today?</h2>
      <p className="form-subtitle">Enter the products you want to compare below</p>
      
      <form onSubmit={handleSubmit}>
        <div className="product-inputs">
          {products.map((product, index) => (
            <div key={index} className="product-input-container">
              <input
                type="text"
                value={product}
                onChange={(e) => handleProductChange(index, e.target.value)}
                placeholder={`Product ${index + 1}`}
                className="product-input-field"
              />
              {products.length > 2 && (
                <button 
                  type="button" 
                  className="btn-icon btn-remove"
                  onClick={() => removeProductInput(index)}
                  aria-label="Remove product"
                >
                  <FaTrash />
                </button>
              )}
            </div>
          ))}
          {products.length < 4 && (
            <button 
              type="button" 
              className="btn-icon btn-add"
              onClick={addProductInput}
              aria-label="Add product"
            >
              <FaPlus />
            </button>
          )}
        </div>
        
        <div className="form-actions">
          <button 
            type="submit" 
            className="btn btn-primary" 
            disabled={isSubmitting || products.filter(p => p.trim()).length < 2}
          >
            {isSubmitting ? 'Processing...' : 'Compare Products'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default ComparisonForm; 